import Select, { SelectProps } from 'components/molecules/Select';
import { convertReferenceListToSelectOptions } from 'utils/index';
import { SelectOption } from 'utils/frontendTypes';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';

function SelectTopicTag({
  selectedTopics,
  onCreate,
  ...rest
}: Partial<SelectProps> & {
  selectedTopics?: SelectOption[];
  onCreate: (option: SelectOption) => any;
}) {
  const options = useSelector(({ data }: RootState) => convertReferenceListToSelectOptions(data.topics.data));

  return (
    <Select
      dataDurableId="conversationPromptSelectTopic"
      isMulti
      noOptionsMessage={() => 'Add tags'}
      isCreateable
      placeholder="Add tags"
      onCreateOption={(text) => onCreate({ label: text, value: text })}
      className="border border-blueLightest rounded shadow text-neutral-800 font-sm"
      value={selectedTopics}
      components={{ DropdownIndicator: null }}
      defaultOptions
      options={options}
      {...rest}
    />
  );
}

export default SelectTopicTag;
